import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Icon } from "@src/components/atoms";
import EmailExamplesCard from "@src/components/cards/manager/EmailExamplesCard";
import EmailScheduleCard from "@src/components/cards/manager/EmailScheduleCard";
import {
  CardContainer,
  HorizontalResponsiveLayout,
} from "@src/components/cards";
import AppUtils from "@src/utils/appUtils";
import ManagerHooks from "@src/context/hooks/managerHooks";
import { useAuthContext } from "@src/context/authContext";
import moment from "moment";
import { useDCContext } from "@src/context/dcContext";
export const ScheduleTooltipItem = (props) => {
  const { count, template, name } = props;

  let iconName = "NotificationSupport";
  if (template.includes("MILESTONE")) {
    iconName = "NotificationMilestone";
  } else if (
    template.includes("END_PERIOD") ||
    template.includes("YEAR_END") ||
    template.includes("MIDMONTHLY")
  ) {
    iconName = "NotificationReport";
  } else if (template.includes("NEWUSER") || template.includes("KICKOFF")) {
    iconName = "NotificationNew";
  }

  return (
    <div className="flex justify-start p-3">
      <Icon
        name={iconName}
        backgroundColor="transparent"
        padding={false}
        centered={false}
        size="2xl"
        className="-mt-1"
      />
      <div className="ml-2 text-sm font-medium">
        <div className="text-left text-black">{count}</div>
        <div className="text-neutral-500 whitespace-nowrap">{name}</div>
      </div>
    </div>
  );
};
const allowedEmailTemplates = [
  "NEWUSER",
  "NEWUSER_SHIPPING",
  "REPORT_KICKOFF",
  "REPORT_KICKOFF_SHIPPING",
  "REPORT_MIDMONTHLY",
  "REPORT_MIDMONTHLY_SHIPPING",
  "REPORT_END_PERIOD",
  "REPORT_END_PERIOD_SHIPPING",
  "MILESTONES",
  "MILESTONES_SHIPPING",
];
const EmailsSection = (props) => {
  const {
    industry,
    isLoading = false,
    exampleTitle,
    exampleExpand,
    exampleDropdownOnChange,
    exampleTemplateOptions,
    exampleTemplateImage,
    scheduleTitle,
    notificationPeriodOptions,
    selectedNotificationPeriod,
    selectedNotificationPeriodOnChange,
    selectedDay,
    selectedDayOnChange,
    teamId,
  } = props;

  const auth = useAuthContext();
  const dc = useDCContext();
  const { getDynamicReplacement, existsDynamicReplacements } = dc;

  const range = AppUtils.getDateRangeFromPeriodKey(selectedNotificationPeriod);

  const [formatted, setFormatted] = useState(null);
  const {
    data: { notificationsPerTemplatePerDay } = {},
    isPending: isPendingDailyData,
    error: errorDailyData,
  } = ManagerHooks.useGetNotificationsPerTemplatePerDay(
    auth.activeRole,
    teamId,
    range.fromTime,
    range.toTime,
  );

  useEffect(() => {
    const data = notificationsPerTemplatePerDay;
    if (!!data) {
      const notificationScheduleMap = {};
      data.forEach((calendarDay) => {
        let calendarDate = moment.utc(calendarDay.day).date();
        calendarDay.notifications.forEach((notification) => {
          if (allowedEmailTemplates.includes(notification.templateName)) {
            //DC notifications__ should remove the "_shipping" bit
            const dcKey = `notifications__${notification.templateName.toLowerCase().replace("_shipping", "")}__name`;
            if (existsDynamicReplacements(dcKey)) {
              const emailTemplateName = getDynamicReplacement(
                dcKey,
                {},
                null,
                true,
              );
              if (!notificationScheduleMap[calendarDate]) {
                notificationScheduleMap[calendarDate] = [];
              }
              notificationScheduleMap[calendarDate].push(
                <ScheduleTooltipItem
                  count={notification.countSent}
                  template={notification.templateName}
                  name={emailTemplateName}
                />,
              );
            } else {
              console.warn("missing DC key ", dcKey);
            }
          } else {
            console.warn(
              "skipped adding notification to calendar ",
              notification,
            );
          }
        });
      });
      setFormatted(notificationScheduleMap);
    }
  }, [notificationsPerTemplatePerDay]);

  return (
    <div
      className="w-full flex flex-col-reverse lg:flex-row justify-center items-stretch gap-2"
      style={{ minHeight: "400px" }}
    >
      <HorizontalResponsiveLayout
        horizontal={{ ratio: [3, 2] }}
        vertical={{ reverse: true }}
        gap={2}
        breakpoint="tablet"
      >
        <CardContainer padding={false} shadow={false} allowOverflow>
          <EmailExamplesCard
            industry={industry}
            title={exampleTitle}
            expand={exampleExpand}
            exampleDropdownOnChange={exampleDropdownOnChange}
            exampleTemplateOptions={exampleTemplateOptions}
            exampleTemplateImage={exampleTemplateImage}
          />
        </CardContainer>
        <CardContainer padding={false} shadow={false} allowOverflow>
          {errorDailyData ? (
            <div className="text-red-500 p-5">
              Error fetching notification schedule data...
            </div>
          ) : (
            <EmailScheduleCard
              title={scheduleTitle}
              notificationPeriodOptions={notificationPeriodOptions}
              selectedNotificationPeriod={selectedNotificationPeriod}
              selectedNotificationPeriodOnChange={
                selectedNotificationPeriodOnChange
              }
              notificationScheduleMap={formatted}
              selectedDay={selectedDay}
              selectedDayOnChange={selectedDayOnChange}
              isLoading={isLoading || isPendingDailyData}
            />
          )}
        </CardContainer>
      </HorizontalResponsiveLayout>
    </div>
  );
};

// export const emailsSectionControls = {};
// EmailsSection.propTypes = AppUtils.getPropTypeFromControls(emailsSectionControls);
export default EmailsSection;
